export const ROUTES = {
    accounts: {
        base: '/accounts',
        cancelled: '/account-cancelled',
        forgotPassword: '/forgot-password',
        login: '/login',
        resetPassword: '/reset-password/:token',
        settings: '/accounts/:view/:action?/:id?',
    },
    admin: {
        base: '/admin',
        settings: '/admin/:view/:action?',
        settingAccount: '/admin/accounts/view/:id/:view?/:action?/:entityId?',
    },
    documents: {
        base: '/documents',
        edit: '/documents/edit/:documentId/:view/:page?',
        editArea: '/documents/review/id/:documentId/:view/areaId/:areaId',
        index: '/documents/:folder(folder)?/:folderId?',
        ipidImport: '/documents/import/ipid/:view?',
        modelImport: '/documents/model_import/:documentId/:domainId',
        oldView: '/documents/review/id/:documentId',
        publications: '/documents/:documentId/publications',
        view: '/documents/edit/:documentId/document',
    },
    forms: {
        base: '/forms',
        edit: '/forms/edit/:formId/:action',
        viewSubmissions: '/forms/edit/:formId/submissions/:submissionId/view',
    },
    home: '/',
    labels: {
        base: '/labels',
    },
    mediaLibrary: {
        base: '/media-library',
        folder: '/media-library/folder/:folder',
    },
    oke: {
        allChecks: '/oke/checks/all',
        base: '/oke',
        checks: '/oke/checks/:page?',
        reports: '/oke/reports',
        settings: '/oke/settings/:page?',
        team: '/oke/teams/:id/:page',
        teams: '/oke/teams',
        view: '/oke/:view?/:id?/:page?',
    },
    operations: {
        base: '/operations',
        view: `/operations/view/:id/:selectedPage?`,
        viewEntry: '/operations/entry/:id/:opEntryId/:selectedPage?',
        viewLabel: '/operations/entryLabel/:id/:opEntryLabelId/:selectedPage?',
    },
    public: {
        embed: '/public/embed/:view/:documentId/:areaId',
        share: '/share/:slug',
    },
    publications: {
        base: '/publicaties',
        documentTemplate: '/publicaties/templates',
        documentTemplateEdit: '/publicaties/templates/edit/:templateId/:action',
        edit: '/publicaties/edit/:publicationId/:action/:groupId?',
        guard: '/publicaties/guard',
        kiosk: '/publicaties/kiosk/:page?',
        index: '/publicaties/:folder(folder|list)?/:folderId?/:publicationId?',
        indexFolder: '/publicaties/:folder/:folderId',
        indexFolderSelection: '/publicaties/:folder/:folderId/:publicationId',
        publicationType: '/publicaties/publication-types',
        publicationTypeEdit: '/publicaties/publication-types/edit/:publicationTypeId/:action',
        userGroups: '/publicaties/publication-user-groups/:page/:id?/:publicationId?',
    },
    reimbursements: {
        base: '/reimbursements',
        editReimbursementProduct:
            '/reimbursements/category/:categoryId/reimbursement_product/:reimbursementId/:parentProductId/:productId/:selectedProductId',
    },
    security: {
        checkSsoToken: '/sso/check_token/jwt/:code',
        logout: '/logout',
    },
    tags: {
        base: '/tags',
        index: '/tags/:folder(folder)?/:folderId?',
    },
    tasks: {
        base: '/tasks',
        tasks: '/tasks/:action?',
        teams: {
            base: '/tasks/teams',
            team: '/tasks/teams/:id/:page',
        },
    },
    translations: {
        base: '/translations',
        edit: '/translations/translate/:language/:translationContainerId/:entityType/:entityId'
    },
    welcome: {
        base: '/welcome',
        createAccount: '/welcome/create-your-account',
        signUp: '/welcome/sign-up',
    },
};
